export default "__VITE_ASSET__WRl9sHaQ__"